import styled from 'styled-components'
import Box from 'components/shared/Box'

export const StyledAccordionItem = styled(Box)`
    border-top: ${({ theme }) => `1px solid ${theme.colors.grayscale_300}`};

    &:first-child {
        border-top: 0;
    }
`
